import { Container } from '@reporting/rp-app-host';

export function formatTitle(container: Container): string {
	let template = container.settings.get('title.format');
	const values: Record<string, string|number> = {
		accounting: container.accountingProvider.a,
		company_name: container.accountingProvider.accounting.company,
		service_name: 'Reporting.bi'
	};

	template = template || '{company_name} - {service_name}';
	return template.replace(/{(\w+)}/g, (_: any, key: string) => values[key] || '');
}
